package one.healthium.tutorial.di

import one.healthium.tutorial.data.AppTutorialRepository
import one.healthium.tutorial.domain.TutorialInteractor
import one.healthium.tutorial.domain.TutorialRepository
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val tutorialDataModule = module {
    singleOf(::AppTutorialRepository) bind TutorialRepository::class
    factoryOf(::TutorialInteractor)
}